import { render, staticRenderFns } from "./baseMaterial.vue?vue&type=template&id=4e786d38&scoped=true&"
import script from "./baseMaterial.vue?vue&type=script&lang=js&"
export * from "./baseMaterial.vue?vue&type=script&lang=js&"
import style0 from "./baseMaterial.vue?vue&type=style&index=0&id=4e786d38&prod&lang=less&scoped=true&"
import style1 from "./baseMaterial.vue?vue&type=style&index=1&id=4e786d38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e786d38",
  null
  
)

export default component.exports